import React from "react";
import { connect } from "react-redux";
import { setMessage } from "../../redux/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    const { message } = state.common;
    return {
      message: message,
    };
  }
  return connect(mapStateToProps, { setMessage })(Container);
};
